import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Panel, Group as PanelGroup, Separator as PanelResizeHandle, usePanelRef } from 'react-resizable-panels';
import styles from './index.module.scss';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { LeftPanel } from './components/LeftPanel';
import { MiddlePanel } from './components/MiddlePanel';
import { RightPanel } from './components/RightPanel';

const Index = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLeftCollapsed, setIsLeftCollapsed] = useState(false);
  const leftPanelRef = usePanelRef();

  useEffect(() => {
    const session_id = localStorage.getItem('session_id') || '';
    const event = new URLSearchParams(location.search).get('event');
    if (event === 'login' && !session_id) {
      dispatch({
        type: 'global/setShowLogin',
        payload: true,
      });
    }
  }, [location, dispatch]);

  return (
    <div className={styles.indexBox}>
      <Header />

      <main className={styles.mainContent}>
        <PanelGroup orientation="horizontal">
          <Panel
            id="left"
            panelRef={leftPanelRef}
            defaultSize="20%"
            minSize="15%"
            maxSize="30%"
            collapsible
            collapsedSize="48px"
            onResize={() => {
              const collapsed = leftPanelRef.current?.isCollapsed() ?? false;
              setIsLeftCollapsed(collapsed);
            }}
          >
            <LeftPanel
              isCollapsed={isLeftCollapsed}
              onToggleCollapse={() => {
                if (isLeftCollapsed) {
                  leftPanelRef.current?.expand();
                } else {
                  leftPanelRef.current?.collapse();
                }
              }}
            />
          </Panel>

          <PanelResizeHandle className={styles.resizeHandle} />

          <Panel id="middle" defaultSize="40%" minSize="25%">
            <MiddlePanel />
          </Panel>

          <PanelResizeHandle className={styles.resizeHandle} />

          <Panel id="right" defaultSize="40%" minSize="25%">
            <RightPanel />
          </Panel>
        </PanelGroup>
      </main>

      <Footer />
    </div>
  );
};

export default Index;
